import { APP_ROUTES } from '@/common/constants'

export const ORDER_FROM = {
    PORTFOLIO: 'portfolio',
    DASHBOARD: 'dashboard',
    INVEST: 'invest',
    FIND_STOCKS: 'find_stocks',
    CAMPAIGNS: 'campaigns',
    BUNDLES: 'bundles',
} as const

export type OrderFrom = (typeof ORDER_FROM)[keyof typeof ORDER_FROM]

export const ORDER_ENTRY_POINT = {
    BUY_MORE: 'buy_more',
    SECURITY_LINK: 'security_link',
    TRENDING_ETF: 'trending_etf',
    FILTERS: 'filters',
    BUY_SHARES: 'buy_shares',
    BUNDLE_CHECKOUT: 'bundle_checkout',
    ETF_CARD: 'etf_card',
    RECOMMENDED_ETF: 'recommended_etf',
    INSTRUMENT_SEARCH: 'instrument_search',
    GETTING_STARTED: 'getting_started',
} as const

export function resolveOrderFromPathname(pathname: string): OrderFrom | null {
    if (pathname === APP_ROUTES.DASHBOARD) return ORDER_FROM.DASHBOARD
    if (pathname.startsWith(APP_ROUTES.INVEST)) return ORDER_FROM.INVEST
    if (pathname.startsWith(APP_ROUTES.PORTFOLIO)) return ORDER_FROM.PORTFOLIO
    if (pathname.startsWith(APP_ROUTES.FIND_STOCKS)) return ORDER_FROM.FIND_STOCKS
    if (pathname.startsWith(APP_ROUTES.CAMPAIGNS)) return ORDER_FROM.CAMPAIGNS
    if (pathname.startsWith(APP_ROUTES.BUNDLES)) return ORDER_FROM.BUNDLES
    return null
}
